/* eslint-disable no-unused-vars */
import React from 'react'
import { Badge, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import translate from '../../../helper/translate'
import Formatter from '../../../helper/formatter'
import { columnResource } from '../../../helper/translatePage/languageResource'
import dataType from '../../../helper/constant/dataType'

const Nmid = (actionFunction, languange) => ({
  key: 'id',
  columns: [
    {
      name: translate('name', languange, columnResource),
      selector: 'nama',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Tempat Lahir',
      selector: 'tempat_lahir',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Tanggal Lahir',
      selector: 'tgl_lahir',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'No KTP',
      selector: 'no_ktp',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'No NPWP',
      selector: 'no_npwp',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'No HP',
      selector: 'no_hp',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Jenis Usaha',
      selector: 'jenis_usaha',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Nama Aplikasi / Domain Merchant',
      selector: 'nama_aplikasi',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Url Website',
      selector: 'url_website',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Email',
      selector: 'email',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Nama Usaha',
      selector: 'nama_usaha',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Alamat Usaha',
      selector: 'alamat_usaha',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Kota / Kabupaten',
      selector: 'kabupaten',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Kode Pos',
      selector: 'kode_pos',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Nama NMID',
      selector: 'nama_nmid',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Pendapatan Per Tahun',
      selector: 'pendapatan',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: true,
      cell: (row) => {
        let word
        let color
        if (row.status) {
          word = translate('active', languange, columnResource)
          color = 'success'
        } else {
          word = translate('notActive', languange, columnResource)
          color = 'danger'
        }
        return <Badge variant={color}>{word}</Badge>
      },
      type: dataType.ENUM,
      showFilter: true,
      default_value: [
        {
          id: false,
          name: translate('notActive', languange, columnResource),
        },
        {
          id: true,
          name: translate('active', languange, columnResource),
        },
      ],
    },
    // {
    //   name: translate('action', languange, columnResource),
    //   cell: (row) => {
    //     return (
    //       <div style={{ flexDirection: 'column' }}>
    //         <div>
    //           <Button
    //             size="sm"
    //             variant="outline-info"
    //             className="mr-1"
    //             data-action="hapus"
    //             onClick={(e) => actionFunction(row, e)}
    //           >
    //             <FontAwesomeIcon fixedWidth icon={faPencilAlt} />
    //           </Button>
    //         </div>
    //       </div>
    //     )
    //   },
    //   showFilter: false,
    // },
  ],
})

export default Nmid
